var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoneyRecive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91669 11.4583C7.91669 12.2666 8.5417 12.9166 9.30836 12.9166H10.875C11.5417 12.9166 12.0834 12.3499 12.0834 11.6416C12.0834 10.8833 11.75 10.6083 11.2584 10.4333L8.75002 9.55828C8.25835 9.38328 7.92503 9.11662 7.92503 8.34995C7.92503 7.64995 8.46668 7.07495 9.13335 7.07495H10.7C11.4667 7.07495 12.0917 7.72495 12.0917 8.53328",
    stroke: "#6E7E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.25V13.75",
    stroke: "#6E7E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 9.99996C18.3334 14.6 14.6 18.3333 10 18.3333C5.40002 18.3333 1.66669 14.6 1.66669 9.99996C1.66669 5.39996 5.40002 1.66663 10 1.66663",
    stroke: "#6E7E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 2.5V5.83333H17.5",
    stroke: "#6E7E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 1.66663L14.1667 5.83329",
    stroke: "#6E7E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyRecive);
export default __webpack_public_path__ + "static/media/money-recive.e27e7804c261b3d62543fa2316598063.svg";
export { ForwardRef as ReactComponent };